import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { DataRightsState } from "../../models/mp-common/data-rights-state";

const initialState: DataRightsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.dataRights.getApi, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.dataRights.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpCommonActions.dataRights.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function dataRightsReducer(
	state: DataRightsState | undefined,
	action: Action
): DataRightsState {
	return reducer(state, action);
}
